import { Routes, Route } from "react-router-dom";
import EpicSocial from "./components/Clientpanel/EpicSocial/Index";

const EngageRoutes = () => {
  return (
    <Routes>
      <Route path="generate" element={<EpicSocial />} />
      <Route path="inbox" element={<EpicSocial />} />
      <Route path="calendar" element={<EpicSocial />} />
      <Route path="history" element={<EpicSocial />} />
      <Route path="prompts" element={<EpicSocial />} />
      <Route path="settings" element={<EpicSocial />} />
      <Route path="settings/accounts" element={<EpicSocial />} />
    </Routes>
  );
};

export default EngageRoutes;
